<template>
<div style="height:100%">
  <div class="manage-header">
      <div><h3>{{$store.state.module1.isChina?'场所列表':'place list'}}</h3><span v-if="arealist">{{arealist.length}}{{$store.state.module1.isChina?'个场所':''}}</span></div>
      <div style="position:relative;"><input type="text" :placeholder="$store.state.module1.isChina?'请输入场所名称':'Enter place name'" @input="filterList" v-model="searchWord"><i class="el-icon-search"></i></div>
  </div>
  <div class="areaList Radius" v-loading="loading">
    <div style="height:0.4rem;width:100%;display:flex;alignItems:center;justifyContent:space-between;"><h3>{{$store.state.module1.isChina?'场所列表':'region list'}}</h3><div><span style="marginRight:0.2rem;color:#409EFF;fontWeight:600;cursor:pointer;text-decoration:underline" @click="showUnit=!showUnit">{{$store.state.module1.isChina?'修改单位':'Unit modification'}}</span><el-button type="primary" @click="addAreaButton" size="small">{{$store.state.module1.isChina?'新建场所':'add place'}}</el-button></div></div>
    <div>
      <el-table :data="arealist" style="width: 100%;">
        <el-table-column :label="$store.state.module1.isChina?'场所名称':'region name'" :width="width*1.25"><template slot-scope="scope">
          <div class="qw">
            <div class="quanquan" :style={background:scope.row.color}>{{ scope.row.name[0] }}</div>
            <div class="quanquan2">
            <p class="qwe" style="textAlign:left">{{ scope.row.name }}</p>
             <span class="ellipsis" style="display:inlineBlock;width:1.5rem;">{{ scope.row.address }}</span>
          </div>
          </div>
        </template></el-table-column>
        <el-table-column prop="ren" :label="$store.state.module1.isChina?'SICCA认证':'SICCA'" :width="width*1.25">
          <template slot-scope="scope">
           <p class="qwe" v-if="scope.row.ren">{{scope.row.ren}}</p>
           <p class="qwe" v-else>{{$store.state.module1.isChina?'暂无':'null'}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="num" :label="$store.state.module1.isChina?'监测点位':'points'" :width="width*1.25">
          <template slot-scope="scope">
           <p class="qwe">{{scope.row.dev_num}}</p>
           <p class="qwe1">{{$store.state.module1.isChina?'室内点位':'Indoor points'}}</p>
          </template>
         </el-table-column>
        <el-table-column prop="devNum" :label="$store.state.module1.isChina?'监测设备':'device'" :width="width">
          <template slot-scope="scope">
           <p class="qwe">{{scope.row.dev_detail.online}}</p>
           <p class="qwe1">{{$store.state.module1.isChina?'正常在线':'Online'}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="creater" :label="$store.state.module1.isChina?'创建人':'creater'" :width="width*1.25">
          <template slot-scope="scope">
           <p class="qwe" v-if="scope.row.creator_name">{{scope.row.creator_name}}</p>
           <p class="qwe" v-else>{{$store.state.module1.isChina?'暂无':'null'}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$store.state.module1.isChina?'创建时间':'Creation time'"  :width="width*1.25">
          <template slot-scope="scope">
           <p class="qwe">{{scope.row.create_time.slice(0,10)}}<br/>{{scope.row.create_time.slice(11)}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="lastTime" :label="$store.state.module1.isChina?'更新时间':'Update time'" :width="width*1.25">
          <template slot-scope="scope">
           <p class="qwe" v-if="scope.row.update_time">{{scope.row.update_time.slice(0,10)}}<br/>{{scope.row.update_time.slice(11)}}</p>
           <p class="qwe" v-else>{{$store.state.module1.isChina?'暂无':'null'}}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$store.state.module1.isChina?'操作':'operation'" :width="width*1.2">
           <template  slot-scope="scope">
            <!-- <i class="el-icon-download" :title="$store.state.module1.isChina?'下载':'Download'" @click="down(scope.row.id)"></i> -->
            <p class="qwe">
              <i class="el-icon-edit" :title="$store.state.module1.isChina?'编辑':'edit'" @click="editAr(scope.row)"></i>
              <i class="el-icon-printer"  :title="$store.state.module1.isChina?'设备':'device'" @click="showDev(scope.row)"></i>
              <i class="el-icon-delete"  :title="$store.state.module1.isChina?'删除':'delete'" @click="deleteAr(scope.row)"></i></p>
          </template>
         </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="dialogFormType===1?$store.state.module1.isChina?'新增场所':'Add place':$store.state.module1.isChina?'编辑场所':'Edit place'" :visible.sync="dialogFormVisible" width="30%">
       <el-form label-position="left">
         <el-form-item :label="$store.state.module1.isChina?'名称':'name'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="addAreaData.name"></el-input>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'地址':'address'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="addAreaData.address"></el-input>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'背景图片':'background picture'" :label-width="formLabelWidth">
           <el-col :span="10"><el-input auto-complete="off" v-model="file.name"></el-input></el-col>
           <el-col :span="2"><el-button type="primary" style="position:relative;">{{$store.state.module1.isChina?'选择图片':'Select Picture'}}<input type="file" @change="upImg"  style="opacity:0;width:100%;height:100%;
           top:0;left:0;position:absolute;"/></el-button></el-col>
         </el-form-item>
       <el-form-item :label="$store.state.module1.isChina?'场所颜色':'color'" :label-width="formLabelWidth">
           <span class="colorRadio" v-for="n in 5" :key="n" :style="{background: color[n-1]}" @click="choseColor(n)" :class="index===n?'selectedColor':''"> </span>
        </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dialogFormVisible = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
         <el-button type="primary" @click="addA()">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
       </div>
    </el-dialog>
    <el-dialog :title="$store.state.module1.isChina?'污染物单位':'unit'" :visible.sync="showUnit" width="30%">
      <p v-for="(unit, index) in units[0]" :key="index" class="unit">
          <span>{{unit.name}}:</span>
          <el-radio v-model="U[index].unit" :label="units[0][index].unit">{{units[0][index].unit}}</el-radio>
          <el-radio v-model="U[index].unit" :label="units[1][index].unit">{{units[1][index].unit}}</el-radio>
      </p>
      <div slot="footer" class="dialog-footer">
         <el-button @click="showUnit = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
         <el-button type="primary" @click="choseUnit()">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
      </div>
    </el-dialog>
  </div>
   </div>
</template>

<script>
import { stringTime, requestData, requestData2 } from '../../../assets/js/commont.js'
import { Mixin } from '../../../mixins/index.js'
export default {
  mixins: [Mixin],
  inject: ['reToken'],
  data () {
    return {
      showUnit: false,
      loading: false,
      width: 128,
      searchWord: '',
      devsId: [],
      arealist: [],
      dialogFormVisible: false,
      dialogFormType: 1,
      formLabelWidth: '70px',
      color: ['#01A3FF', '#FF5679', '#A157EC', '#FFD300', '#00CF69'],
      areaColor: '#01A3FF',
      index: 1,
      addAreaData: {
        name: '',
        address: ''
      },
      file: '',
      editAreaId: '',
      units: [
        [
          {
            name: 'PM2.5',
            unit: 'μg/m³'
          },
          {
            name: 'TVOC',
            unit: 'ppb'
          },
          {
            name: 'HCHO',
            unit: 'ppb'
          }
        ],
        [
          {
            name: 'PM2.5',
            unit: 'mg/m³'
          },
          {
            name: 'TVOC',
            unit: 'mg/m³'
          },
          {
            name: 'HCHO',
            unit: 'mg/m³'
          }
        ]
      ]
    }
  },
  mounted () {
    // 更新table尺寸------------------------------------------
    this.updateTable()
    var self = this
    window.onload = function () {
      self.updateTable()
    }
    window.onresize = function () {
      self.updateTable()
    }
  },
  methods: {
    // 获取区域设备列表供数据下载
    getDevList (id) {
      return new Promise((resolve, reject) => {
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          area_id: parseInt(id),
          limit: 99,
          page: 1,
          state: '',
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.getDeviceList(requestData(data)).then(res => {
          this.devsId = []
          if (res.length) {
            res.forEach(item => {
              this.devsId.push(item.code)
            })
            resolve(1)
          } else {
            reject(new Error('暂无设备'))
          }
        })
      })
    },
    down (code) {
      this.getDevList(code).then(res => {
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          codes: this.devsId.join(','),
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.checklog(requestData(data)).then(res => {
          window.open(res)
        }).catch(rea => {
          this.$message({
            message: rea.message,
            type: 'warning'
          })
        })
      }).catch(() => {
        this.$message({
          message: this.$store.state.module1.isChina ? '暂无设备' : 'The device does not exist',
          type: 'warning'
        })
      })
    },
    // 选择单位
    choseUnit () {
      window.localStorage.setItem('unit', JSON.stringify({
        pm25: this.U[0].unit,
        tvoc: this.U[1].unit,
        hcho: this.U[2].unit
      }))
      this.showUnit = false
    },
    // 添加场所按钮
    addAreaButton () {
      this.dialogFormVisible = true
      this.dialogFormType = 1
      this.addAreaData.name = ''
      this.addAreaData.address = ''
      this.file = ''
    },
    updateTable () {
      var oWidth1 = document.body.clientWidth || document.documentElement.clientWidth
      this.width = 125 / 1496 * oWidth1
    },
    // 筛选数据函数------------------------------------------------------------
    filterList () {
      this.arealist = this.proAreaList.filter(item => {
        return item.name.indexOf(this.searchWord) !== -1
      })
    },
    // 获取场所列表函数----------------------------------
    getAList () {
      this.loading = true
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        limit: 99,
        project_id: window.localStorage.getItem('proId'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getProAreaList(requestData(data)).then(() => {
        this.loading = false
      })
    },
    // 选择颜色函数-----------------------------------------
    choseColor (index) {
      this.index = index
      this.areaColor = this.color[index - 1]
    },
    // 上传图片函数-------------------------------------
    upImg (value) {
      var file = value.target.files[0].name
      var index = file.lastIndexOf('.')
      var geshi = file.slice(index)
      if (geshi !== '.png' && geshi !== '.jpg' && geshi !== '.jpeg' && geshi !== '.gif') {
        this.$message({
          message: this.$store.state.module1.isChina ? '只支持png,jpg,jpeg,gif格式图片' : 'Only PNG, JPG, JPEG, GIF format images are supported',
          type: 'warning'
        })
      } else {
        this.file = value.target.files[0]
      }
    },
    // 添加场所函数------------------------------------------
    addA () {
      if (this.addAreaData.name && this.addAreaData.address && this.file) {
        this.dialogFormVisible = false
        var time = stringTime(this.$myTime())
        // 弹出框类型1 添加
        var data
        var reader = new FileReader()
        reader.readAsDataURL(this.file)
        var self = this
        if (this.dialogFormType === 1) {
          reader.onload = function (e) {
            data = {
              account: window.localStorage.getItem('account'),
              address: self.addAreaData.address,
              color: self.areaColor,
              image: e.target.result,
              name: self.addAreaData.name,
              project_id: window.localStorage.getItem('proId'),
              token: window.localStorage.getItem('token'),
              ts: time
            }
            self.addArea(requestData2(data)).then(res => {
              self.$message({
                message: this.$store.state.module1.isChina ? '添加成功' : 'success',
                type: 'success'
              })
            })
          }
        } else { // 弹出框类型2 修改-------------------
          reader.onload = function (e) {
            data = {
              account: window.localStorage.getItem('account'),
              address: self.addAreaData.address,
              color: self.areaColor,
              id: self.editAreaId,
              image: e.target.result,
              name: self.addAreaData.name,
              project_id: window.localStorage.getItem('proId'),
              token: window.localStorage.getItem('token'),
              ts: time
            }
            self.editArea(requestData2(data)).then(res => {
              self.$message({
                message: this.$store.state.module1.isChina ? '修改成功' : 'success',
                type: 'success'
              })
            })
          }
        }
      } else {
        this.$message({
          message: this.$store.state.module1.isChina ? '请填写完整的信息' : 'Incomplete information',
          type: 'warning'
        })
      }
    },
    // 编辑场所函数------------------------------
    editAr (area) {
      this.dialogFormVisible = true
      this.dialogFormType = 2
      this.addAreaData.name = area.name
      this.addAreaData.address = area.address
      this.editAreaId = parseInt(area.id)
    },
    // 删除场所函数-----------------------------------
    deleteAr (area) {
      this.$confirm(this.$store.state.module1.isChina ? '确定删除此地区否继续?' : 'Are you sure you want to delete?', this.$store.state.module1.isChina ? '提示' : 'Tips', {
        confirmButtonText: this.$store.state.module1.isChina ? '确定' : 'OK',
        cancelButtonText: this.$store.state.module1.isChina ? '取消' : 'Cancel',
        type: 'warning'
      }).then(() => {
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          area_id: parseInt(area.id),
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.delArea(requestData(data)).then(res => {
          this.$message({
            message: this.$store.state.module1.isChina ? '删除成功' : 'success',
            type: 'success'
          })
        }).catch(rea => {
          this.$message({
            message: rea.message,
            type: 'warning'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$store.state.module1.isChina ? '已取消删除' : 'Deletion canceled'
        })
      })
    },
    // 选择区域查看设备
    showDev (area) {
      this.$store.commit('setAreaDev', area.name)
      this.$router.push('/devData')
    }
  },
  destoryed () {
    window.onload = null
    window.onresize = null
  },
  created () {
    this.arealist = this.proAreaList
    // 获取场所信息--------------------
    this.getAList()
  },
  watch: {
    proAreaList (value) {
      this.$nextTick(() => {
        this.arealist = value
      })
    },
    // 增加修改后刷新页面
    File (value) {
      this.$nextTick(() => {
        this.getAList()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.areaList{
  width:100%;
  height:calc(100% - 1.76rem);
  padding:0.2rem;
  overflow:auto;
}
.quanquan{
  width:0.48rem;
  height:0.48rem;
  background:red;
  border-radius:50%;
  position:absolute;
  top:50%;
  left:0;
  color: white;
  font-weight:600;
  transform:translateY(-50%);
  line-height:0.48rem;
  text-align:center;
}
.quanquan2{
    position:absolute;
  left:0.6rem;
   top:50%;
  transform:translateY(-50%);
  p{
    font-weight:600;
    opacity:0.8;
    color:black;
    font-size:0.16rem;
  }
  span{
    font-size:0.12rem;
    font-weight:600;
    display:inline-block;
    width:100%;
    text-align:left;
  }
}
.qw{
  height:0.8rem;
}
  .qwe{
  font-weight:600;
      opacity:0.8;
    color:black;
    font-size:0.16rem;
    text-align:center;
    i{
      margin:0 0.05rem;
      font-size:0.18rem;
      font-weight:600;
    }
  }
    .qwe1{
    text-align:center;
    font-size:0.12rem;
    font-weight:600;
  }
.selectedColor{
  opacity:0.2;
}
.addArea{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0);
    display:flex;
    flex-direction:column;
    .addArea-head{
        flex:0 0 0.4rem;
        display:flex;
        justify-content:space-between;
        margin-bottom:0.2rem;
    }
    .saveAdd{
        height:0.4rem;
        width:1.2rem;
        line-height:0.4rem;
        background:#01A3FF;
        border-radius:0.1rem;
        color:white;
    }
}
.areaImg{
    flex:1;
    overflow:hidden;
    img{
        height:100%;
    }
}
.colorRadio{
    width:0.2rem;
    display:inline-block;
    height:0.2rem;
    background:red;
    border-radius:50%;
    margin:0 0.1rem;
}
.manage-header{
    width:calc(100% + 0.48rem);
    height:1.76rem;
    transform:translate(-0.1rem,-0.1rem);
    background:white;
    box-shadow:inset 8px 8px 8px 2px rgba(0,0,0,0.04);
    text-align:left;
    padding-top:0.4rem;
    padding-left:0.4rem;
    h3{
        margin-bottom:0.2rem;
    }
    div:last-child{
        width:4rem;
        height:0.5rem;
        border:1px solid #ccc;
        border-radius:0.1rem;
        padding:0 0.2rem;
        line-height:0.5rem;
        display:flex;
        align-items:center;
        justify-content:space-between;
    }
    div:first-child{
      display:flex;
      align-items:baseline;
      span{
        color:#01A3FF;
        margin-left:0.2rem;
        font-weight:600;
        font-size:0.14rem;
      }
    }
}
.unit{
    margin:0.2rem;
    span{
      display:inline-block;
      width: 1.2rem;
      font-weight:600;
    }
    .el-radio{
      width:0.7rem;
      font-size:0.12rem;
    }
}
</style>
